import { Box, Grid, Typography } from '@mui/material';
import { Formik, FormikHelpers } from 'formik';
import {
  AppFormikSelectWithKeys,
  AppFormikTextField,
  AppPrimaryButton,
} from 'shared/components/AppComponents';
import PageHeader from 'shared/components/PageHeader';
import { InviteTeamSchema } from 'validators/ManageEmployeesScheme';
import { ManageTeamService } from 'services/ManageTeamService';
import { Utils } from 'shared/helpers';

interface NewInviteTabProps {
  onNewMemberInvite: () => void;
}

const NewInviteTab: React.FC<NewInviteTabProps> = (props) => {
  const { onNewMemberInvite } = props;
  const actionOnFormSubmit = async (
    formValues: any,
    formik: FormikHelpers<any>
  ): Promise<void> => {
    ManageTeamService.create(formValues)
      .then(() => {
        onNewMemberInvite();
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formik.setSubmitting(false);
      });
  };

  return (
    <Box>
      <Box className="app-plain-card pt-3">
        <PageHeader
          title="Invite New Teammate"
          customDescription={
            <Typography className="f16 word-break" sx={{ lineHeight: '30px' }}>
              Send an invitation to join your team via Supabase's secure invite
              system
            </Typography>
          }
        />
        <Box className="content">
          <Formik
            enableReinitialize
            initialValues={{
              inviteMail: '',
              inviteRole: '',
            }}
            validationSchema={InviteTeamSchema([], [])}
            validateOnMount
            onSubmit={(formValues, formik) => {
              actionOnFormSubmit(formValues, formik);
            }}
          >
            {({ handleSubmit, isSubmitting, isValid }) => (
              <form autoComplete="off">
                <Box>
                  <Typography variant="h4">Email Address</Typography>
                  <AppFormikTextField
                    name="inviteMail"
                    placeholder="team@example.com"
                  />
                </Box>
                <Box>
                  <Typography variant="h4">Role</Typography>
                  <AppFormikSelectWithKeys
                    name="inviteRole"
                    className="rework-selection"
                    notched={false}
                    labelId="fix-selection-label"
                    testid="solicitor-dropdown"
                    MenuProps={{
                      className: 'menu-fix-selection single-fix-rework',
                    }}
                    placeholder="Select Role"
                    notEmphasized
                    notSelectablePlaceholder
                    label=""
                    titleKey="title"
                    valueKey="value"
                    items={[
                      { title: 'Admin', value: 'Admin' },
                      { title: 'Member', value: 'Member' },
                      { title: 'Auditor', value: 'Auditor' },
                      {
                        title: 'Governance Reviewer',
                        value: 'GovernanceReviewer',
                      },
                    ]}
                  />
                </Box>

                <Box pt={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} className="end-content">
                      <AppPrimaryButton
                        className="p-3"
                        testid="button-forgot"
                        fullWidth
                        title="Send Invitation"
                        isLoading={isSubmitting}
                        loadingSize={22}
                        disabled={!isValid || isSubmitting}
                        onClick={handleSubmit}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </Box>
    </Box>
  );
};

export default NewInviteTab;
